import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";

export default class SetTimeOnPlay extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.EndOfPlay;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        play.time = gameContext.getTime();
    }
}
